import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchAufgaben(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('aufgaben')
    .select('id, titel, beschreibung, status, faelligkeit, prioritaet, updated_at')
    .or(`titel.ilike.${pattern},beschreibung.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Aufgaben search error:', error);
    return [];
  }

  return (data || [])
    .filter(a => matchFn(term, a.titel, a.beschreibung))
    .slice(0, limit)
    .map(a => {
      const title = a.titel || 'Ohne Titel';
      const subtitle = a.beschreibung?.substring(0, 50) || undefined;
      
      return {
        id: a.id,
        type: 'aufgaben' as SearchSectionId,
        title,
        subtitle,
        badge: a.status || 'Aufgabe',
        data: a,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, a.updated_at)
      };
    });
}
